"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylesInjection = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const cache_1 = __importDefault(require("@emotion/cache"));
const react_1 = require("@emotion/react");
const uuid_1 = require("uuid");
/**
 * Generates a UUID-like string using only alphabetic characters
 * @param alphabet - The alphabet to use for generating the string (default: lowercase a-z)
 * @returns A string containing only characters from the provided alphabet
 * @description Converts a standard UUID into an alphabetic string by mapping bytes to alphabet indices
 */
const uuidAlpha = (alphabet = 'abcdefghijklmnopqrstuvwxyz') => {
    let alpha = '';
    const base = alphabet.length;
    for (let j = 0; j < 5; j++) { // repeat 5 times to get a final id with 20 chars (5 * 4)
        const bytes = Buffer.from((0, uuid_1.v4)(), 'hex');
        for (let i = 0; i < bytes.length; i++) {
            const byte = bytes[i];
            alpha += alphabet[byte % base];
        }
    }
    return alpha;
};
const StylesInjection = (props) => {
    const emotionCache = (0, cache_1.default)({
        container: props.injectionPoint,
        key: uuidAlpha(),
        stylisPlugins: [],
    });
    return (0, jsx_runtime_1.jsx)(react_1.CacheProvider, { value: emotionCache, children: props.children });
};
exports.StylesInjection = StylesInjection;
